import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, BrowserRouter} from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './Redux/store';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <>
  {/* <React.StrictMode> */}
  {/* <I18nextProvider i18n={i18n}> */}
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
    </HelmetProvider>
  {/* </I18nextProvider> */}
{/* </React.StrictMode> */}
</>
);

reportWebVitals();
